import * as t from 'io-ts'
import { localStorageAtom, useAtom } from 'klyva'

const darkModeLocalStorageAtom = localStorageAtom(
  window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? true,
  'darkMode',
  t.boolean.is,
)

const useDarkMode = () => useAtom(darkModeLocalStorageAtom)

export default useDarkMode
